import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, UserRound, Sparkles } from "lucide-react";

export default function Navbar({ transparent = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="global-navbar"
      className={`w-full sticky top-0 z-40 ${transparent ? "bg-white/70 backdrop-blur-md" : "bg-white"} border-b border-stone-200`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 font-heading font-black text-2xl tracking-tighter text-stone-900">
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-2xl bg-pink-500 text-white">
            <Sparkles className="w-5 h-5" />
          </span>
          Foldora
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-stone-700">
          <a href="/#services" data-testid="nav-services" className="hover:text-pink-600">Services</a>
          <a href="/#how" data-testid="nav-how" className="hover:text-pink-600">How it works</a>
          <a href="/#pricing" data-testid="nav-pricing" className="hover:text-pink-600">Pricing</a>
          <a href="/#membership" data-testid="nav-membership" className="hover:text-pink-600">Membership</a>
          <a href="/#about" data-testid="nav-about" className="hover:text-pink-600">About</a>
          <a href="/faq" data-testid="nav-faq" className="hover:text-pink-600">FAQ</a>
          <a href="/contact" data-testid="nav-contact" className="hover:text-pink-600">Contact</a>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" && (
                <Button
                  data-testid="nav-admin-btn"
                  variant="outline"
                  className="rounded-full border-stone-300"
                  onClick={() => navigate("/admin")}
                >
                  Admin
                </Button>
              )}
              <Button
                data-testid="nav-dashboard-btn"
                variant="outline"
                className="rounded-full border-stone-300"
                onClick={() => navigate("/dashboard")}
              >
                <UserRound className="w-4 h-4 mr-1" /> {user.name?.split(" ")[0] || "Account"}
              </Button>
              <Button
                data-testid="nav-logout-btn"
                variant="ghost"
                className="rounded-full"
                onClick={async () => { await logout(); navigate("/"); }}
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Button
                data-testid="nav-login-btn"
                variant="ghost"
                className="rounded-full"
                onClick={() => navigate("/login")}
              >
                Log in
              </Button>
              <Button
                data-testid="nav-signup-btn"
                className="rounded-full bg-pink-500 hover:bg-pink-600 text-white font-bold px-5"
                onClick={() => navigate("/signup")}
              >
                Get started
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
